require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-slaughterhouse-event.json") })
        }
      }, "path---project-slaughterhouse-event");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-slaughterhouse-event!./.cache/json/project-slaughterhouse-event.json
// module id = 353
// module chunks = 231608221292675